import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M3.5 12c0-4.663 3.837-8.5 8.5-8.5s8.5 3.837 8.5 8.5v2h-2.25a.754.754 0 0 0-.75.75v6.5c0 .414.336.75.75.75H19c1.646 0 3-1.354 3-3v-7c0-5.523-4.477-10-10-10S2 6.477 2 12v7c0 1.646 1.354 3 3 3h.75c.411 0 .75-.339.75-.75v-6.5a.754.754 0 0 0-.75-.75H3.5zm17 3.5V19c0 .823-.677 1.5-1.5 1.5v-5zM3.5 19v-3.5H5v5c-.823 0-1.5-.677-1.5-1.5m9.25-7.25A.754.754 0 0 0 12 11a.754.754 0 0 0-.75.75v10.5c0 .411.339.75.75.75s.75-.339.75-.75zm-4 2.25c.411 0 .75.339.75.75v4.5c0 .411-.339.75-.75.75a.754.754 0 0 1-.75-.75v-4.5c0-.411.339-.75.75-.75m7.25.75a.754.754 0 0 0-.75-.75.754.754 0 0 0-.75.75v4.5c0 .411.339.75.75.75s.75-.339.75-.75z",
      class: "hidden qmusic:block",
      style: {"fill-rule":"nonzero"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M3.5 12c0-4.663 3.837-8.5 8.5-8.5s8.5 3.837 8.5 8.5v2h-2.25a.754.754 0 0 0-.75.75v6.5c0 .414.336.75.75.75H19c1.646 0 3-1.354 3-3v-7c0-5.523-4.477-10-10-10S2 6.477 2 12v7c0 1.646 1.354 3 3 3h.75c.411 0 .75-.339.75-.75v-6.5a.754.754 0 0 0-.75-.75H3.5zm17 3.5V19c0 .823-.677 1.5-1.5 1.5v-5zM3.5 19v-3.5H5v5c-.823 0-1.5-.677-1.5-1.5",
      class: "hidden joe-be:block joe:block",
      style: {"fill-rule":"nonzero"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M3.5 12c0-4.663 3.837-8.5 8.5-8.5s8.5 3.837 8.5 8.5v2h-2.25a.754.754 0 0 0-.75.75v6.5c0 .414.336.75.75.75H19c1.646 0 3-1.354 3-3v-7c0-5.523-4.477-10-10-10S2 6.477 2 12v7c0 1.646 1.354 3 3 3h.75c.411 0 .75-.339.75-.75v-6.5a.754.754 0 0 0-.75-.75H3.5zm17 3.5V19c0 .823-.677 1.5-1.5 1.5v-5zM3.5 19v-3.5H5v5c-.823 0-1.5-.677-1.5-1.5",
      class: "hidden willy:block",
      style: {"fill-rule":"nonzero"}
    }, null, -1)
  ])))
}
export default { render: render }